"use client";

import { auth } from "@/config/firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";

const AUTH_RESTORE_TIMEOUT_MS = 8000;

const waitForCurrentUser = () =>
  new Promise((resolve) => {
    if (auth.currentUser) {
      resolve(auth.currentUser);
      return;
    }

    let settled = false;
    let unsubscribe = () => {};
    const timeout = setTimeout(() => {
      if (settled) return;
      settled = true;
      unsubscribe();
      resolve(null);
    }, AUTH_RESTORE_TIMEOUT_MS);

    unsubscribe = onAuthStateChanged(auth, (user) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      unsubscribe();
      resolve(user);
    });
  });

export const getDealerAuthHeaders = async ({ forceRefresh = false } = {}) => {
  const user = auth.currentUser || (await waitForCurrentUser());
  const token = await user?.getIdToken(forceRefresh);
  return token ? { Authorization: `Bearer ${token}`, "X-AEL-Client": "web" } : {};
};
